import { Component, OnInit, inject } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { BrowserMessagesService, LoaderComponent, SideMenuHeadlineComponent, TreeComponent, TreeItem } from '@rbb/ng-web-template-lib';
import { AdminOrgUnit } from '../../data/admin-org-unit';
import { ApprovalUserData } from '../../data/approval-user-data';
import { EmployeeType } from '../../types/employee-type';
import { AdminEmployeeListItem } from '../../data/admin-employee-list-item';
import { FormsModule } from '@angular/forms';
import { ProcessListItem } from '../../data/process-list-item';
import { ProcessesTableComponent } from '../processes-table/processes-table.component';

@Component({
  selector: 'app-admin-explorer',
  templateUrl: './admin-explorer.component.html',
  styleUrls: ['./admin-explorer.component.css'],
  imports: [FormsModule, ProcessesTableComponent, LoaderComponent, SideMenuHeadlineComponent, TreeComponent]
})
export class AdminExplorerComponent implements OnInit {
  private adminService = inject(AdminService);
  private browserMessagesService = inject(BrowserMessagesService);

  treeItem: TreeItem | undefined;
  orgUnits: AdminOrgUnit[] | undefined;
  selectedItem: (AdminOrgUnit & AdminEmployeeListItem) | undefined;
  employee: ApprovalUserData | undefined;
  processes: ProcessListItem[] | undefined;

  ngOnInit(): void {
    this.getOrgUnits();
  }

  getOrgUnits(): void {
    this.adminService.getOrgUnits().subscribe({
      next: (data) => {
        this.orgUnits = data;
        if (data.length === 1) {
          this.treeItem = AdminOrgUnit.toTreeItem(data[0]);
        } else {
          this.treeItem = {
            name: 'Rundfunk Berlin-Brandenburg',
            children: data.map(ou => AdminOrgUnit.toTreeItem(ou)),
            object: null
          };
        }
      },
      error: err => this.browserMessagesService.showHttpError(err)
    });
  }

  getEmployee(): void {
    this.employee = undefined;
    this.processes = undefined;
    if (this.selectedItem?.id && this.selectedItem?.username && this.selectedItem.uidNumber) {
      this.adminService.getEmployee(this.selectedItem.id).subscribe({
        next: (data) => {
          this.employee = data;
        },
        error: err => this.browserMessagesService.showHttpError(err)
      });
      this.adminService.getEmployeeProcesses(this.selectedItem.username, this.selectedItem.uidNumber).subscribe({
        next: (data) => {
          this.processes = data;
        },
        error: err => this.browserMessagesService.showHttpError(err)
      });
    }
  }

  protected readonly EmployeeType = EmployeeType;
}
